
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/your-groups",
      function () {
        return require("private-next-pages/groups/your-groups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/your-groups"])
      });
    }
  